<div class="profile-page bg-secondary">
  <main class="pt-4">
    <div class="container wow fadeIn">
    <!--Grid row-->
      <div class="row">
      <!--Grid column-->
        <div class="col-md-12 mb-2">
        <!-- Heading -->
        <h2 class="my-5 h2 text-center">Checkout form</h2>
        <!-- Heading -->
        <h4 class="d-flex justify-content-between align-items-center mb-3">
          <span class="text-muted">Your Credit Balance</span>
          <span class="badge badge-secondary badge-pill">{{currency}}{{balance}}</span>
        </h4>

        <!-- Cart -->
        <ul class="list-group mb-3 z-depth-1">
          <li class="list-group-item d-flex justify-content-between lh-condensed">
            <div>
              <h5 class="my-0">Customer Information</h5>
              {{zesaModel.customerData}}
            </div>
          </li>
          <li class="list-group-item d-flex justify-content-between">
            <span>Token Price </span>
            <strong>ZWD {{zesaModel.salesCurrencyAmount}}</strong>
          </li>
          <li class="list-group-item d-flex justify-content-between">
            <span>Amount To Pay </span>
            <strong>R {{zesaModel.totalAmount}}</strong>
          </li>
        </ul>
        <div>
          <h4 v-if="showPaymentMethods" class="d-flex justify-content-between align-items-center mb-3">
          <span class="text-muted">Payment Methods</span>
          </h4>
          <!-- payment methods-->
          <!-- Cart -->
          <ul v-if="showPaymentMethods" class="list-group mb-3 z-depth-1">
          <li class="list-group-item d-flex">
          <div class="col-md-12">
          <span class="text-muted"><input type="radio"  name="paymentMethod" value="wallet" v-model="paymentMethod" ></span>&nbsp;&nbsp;
          Umbai credits &nbsp;  &nbsp;
          <i class="fa fa-money fa-1x"></i>       
          </div>
          </li>
          <li class="list-group-item d-flex ">
          <div class="col-md-12">
          <span class="text-muted"><input type="radio" name="paymentMethod" checked="true" value="#cc" v-model="paymentMethod" ></span>&nbsp;&nbsp;
          Credit/Cheque card &nbsp;&nbsp;
          <img
          class="img-fluid"
          src="img/visa.svg"
          height="24"
          alt="airtime"
          />  &nbsp;  &nbsp;
          <img
          class="img-fluid"
          src="img/mastercard.svg"
          height="24"
          alt="airtime"
          /> 
          </div>
          </li>
          <li class="list-group-item d-flex">
          <div class="col-md-12">
          <span class="text-muted"><input type="radio" name="paymentMethod" value="#ef" v-model="paymentMethod" ></span>&nbsp;&nbsp;
          InstantEft  &nbsp;  &nbsp;
          <img
          class="img-fluid"
          src="img/instanteft.svg"
          height="24"
          alt="airtime"
          />            
          </div>
          
          </li>
           <li class="list-group-item d-flex">
                   &nbsp;&nbsp;&nbsp;&nbsp; 
                   Have a Coupon? &nbsp; No/Yes  
                     &nbsp;
                      <base-switch @change="ShowCouponBox = !ShowCouponBox"></base-switch>
                        &nbsp;&nbsp;
                        
                      <div class="col-mb-2" v-if="ShowCouponBox">
                        <input class="form-control border border-success form-control-sm" placeholder="Enter Coupon code here" type="text">
                      </div>
                </li>
          </ul>
          <div>
          <button class="btn btn-primary btn-block" type="button" @click="initiatePayment">Pay</button>
          </div>
        </div>
        <!--spinner-->
        <div class="vld-parent">
        <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="fullPage"></loading>
        </div>
        <!--spinner-->
        <form :action="GetPaymetURL()" method="post" id='payfast'>
          <input type="hidden" name="merchant_id" :value="payment.merchantId" placeholder="merchant_id" />
          <input type="hidden" name="merchant_key" :value="payment.merchantKey" placeholder="merchant_key" />
          <input type="hidden" name="return_url" :value="payment.returnUrl" placeholder="return_url" />
          <input type="hidden" name="cancel_url" :value="payment.cancelUrl" placeholder="cancel_url" />
          <input type="hidden" name="notify_url" :value="payment.notifyUrl" placeholder="notify_url" />
          <input type="hidden" name="m_payment_id" :value="payment.mPaymentId" placeholder="m_payment_id" />
          <input type="hidden" name="amount" :value="payment.totalAmount" placeholder="amount" />
          <input type="hidden" name="item_name" :value="payment.itemName" placeholder="item_name" />
          <input type="hidden" name="item_description" :value="payment.itemDescription" placeholder="item_name" />
          <input type="hidden" name="signature" :value="payment.signature" placeholder="signature" />
        </form>
        </div>
      <!--Grid column-->
      </div>
    <!--Grid row-->
    </div>
  </main>
<!--Main layout-->
</div>
